import React from "react";
import Styled from "./EmptyChartDataStyles";
import Grid from "@mui/material/Grid2";

export const EmptyChartData = (props) => {
    const { id, style, textNoChartContent = "Not enough data to show", textNoChartContentSmall = "Please use our system for at least a month to see your first monthly chart", } = props

    return (
        <div
            style={style}
            id={id}
        >
            <Styled.NoChartWrapper container alignItems={"center"} justifyContent={"center"}>
                <Grid item size={12}>
                    <Grid container>
                        <Grid item size={12} container justifyContent={"center"} alignItems={"center"}>
                            <Grid container>
                                <Grid item size={12} container justifyContent={"center"} alignItems={"center"}>
                                    <Styled.NoChartContent>
                                        {textNoChartContent}
                                    </Styled.NoChartContent>
                                </Grid>
                            </Grid>
                            <Grid item size={12} container justifyContent={"center"} alignItems={"center"}>
                                <Styled.NoChartContentSmall>
                                    {textNoChartContentSmall}
                                </Styled.NoChartContentSmall>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Styled.NoChartWrapper>
        </div>
    );
}

export default React.memo(EmptyChartData);